import {mapImages} from "../../shared/data/map-images";
import "./select-map.css"
import {useNavigate} from "react-router-dom";

export default function SelectMap() {
    const navigate = useNavigate();

    function handleImageClick(identifier) {
        console.log(identifier)
        navigate(`/maps/${identifier}`)
    }

    return (
        <div id="container">
            <h1>Choose Map</h1>
            <div id="map-grid">
                {mapImages.map((map, index) => (
                    <div key={index} className="map-card" onClick={() => handleImageClick(map.identifier)}>
                        <img src={map.src} alt={map.name} className="map-image" />
                        <div className="map-name">{map.name}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
